import React from 'react';
import { useGetApplicationsQuery } from './applicationApiSlice'; // Adjust the path if needed
import Application from './Application'; // Import the Application component
import { Box, CircularProgress, Alert, Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ApplicationsList = () => {
  const { data, isLoading, isError, error } = useGetApplicationsQuery();
  const navigate = useNavigate();

  // Handle loading state
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Handle error state with specific error messages
  if (isError) {
    if (error.status === 401) {
      return (
        <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <Alert severity="error" sx={{ marginBottom: 2 }}>
        You must log in to view applications.
      </Alert>
      <Button onClick={() => navigate('/login')} variant="contained" color="primary">
        Login
      </Button>
    </Box>
      );
    } else if (error.status === 404) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
          <Alert severity="info">No applications found.</Alert>
        </Box>
      );
    } else {
      // Handle other errors (e.g., server error)
      console.error('Error fetching applications:', error);
      return (
        <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
          <Alert severity="error">Error fetching applications.</Alert>
          <Button onClick={() => navigate('/login')} variant="contained" color="primary">
        Login
      </Button>

        </Box>
      );
    }
  }

  // Ensure data is available and handle empty applications case
  const applications = data?.ids.map((id) => data?.entities[id]) || [];

  return (
    <Box padding={2} bgcolor="#f5f5f5">
      <Grid container spacing={3} justifyContent="center">
        {applications.length > 0 ? (
          applications.map((application) => (
            <Grid item key={application._id} xs={12} sm={6} md={4}>
              <Application application={application} />
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Alert severity="info">No applications found.</Alert>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default ApplicationsList;